
import { Prop, Vue, Component, Emit } from 'vue-property-decorator'
import { ICollectionReporter } from '@/types/reporter-types'

@Component
export default class extends Vue {
    @Prop({ type: Array, default: () => [], required: true }) data!: Array<ICollectionReporter>

    @Emit('edit')
    private handleEdit(index: number): number {
        return index
    }
    @Emit('remove')
    private handleRemove(id: number): number {
        return id
    }
}
